import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import MyProposals from "@/pages/MyProposals";

export const Route = createFileRoute("/cuenta/presupuestos")({
  component: () => (
    <ProtectedRoute>
      <MyProposals />
    </ProtectedRoute>
  ),
});
